export default __webpack_public_path__ + "static/poster-d6519e5f113b6e3c179def2402ae17f5.png";